import { c as _c } from "react/compiler-runtime";
import { ArrowButtonProperties } from "@website/accommodation-ui/price-calendar-wrapper/types";
import { MaterialIcon } from "@website/icons/material";
import { FC } from "react";
export const ArrowButton: FC<ArrowButtonProperties> = properties => {
  const $ = _c(7);
  const {
    type,
    onClick,
    disabled
  } = properties;
  const t0 = `hidden h-14 w-9 shrink-0 items-center justify-center rounded-lg border bg-white md:flex ${disabled ? "opacity-50" : ""}`;
  const t1 = `chevron_${type}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <MaterialIcon className="text-2xl" name={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== disabled || $[3] !== onClick || $[4] !== t0 || $[5] !== t2) {
    t3 = <button className={t0} disabled={disabled} onClick={onClick}>{t2}</button>;
    $[2] = disabled;
    $[3] = onClick;
    $[4] = t0;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};